import { render } from "./Pengambilan.vue?vue&type=template&id=6014091a"
import script from "./Pengambilan.vue?vue&type=script&lang=js"
export * from "./Pengambilan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__